import { Card, CardContent, CardHeader, CardMedia, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import eventsData from '../data/events.json';

const Events = () => {
    const navigate = useNavigate();

    return (
        <Stack maxWidth="md" sx={{ mt: 4, mb: 4, gap: 3, mx: 'auto' }}>
            <Typography variant="h4" component="h1" gutterBottom align="center">
                Upcoming Events
            </Typography>
            <Typography variant="body1" align="center" paragraph>
                Join us for our exciting events and activities.
            </Typography>
            <Grid container spacing={4}>
                {eventsData.map((event) => (
                    <Grid item xs={12} sm={6} md={4} key={event.id}>
                        <Card variant="elevation"
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                backgroundColor: '#ffffff',
                                boxShadow: 3,
                                '&:hover': { boxShadow: 6 },
                            }}
                            onClick={() => navigate(`/events/${event.id}`)}
                        >
                            <CardHeader title={event.title} subheader={new Date(event.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} />
                            <CardMedia component="img" image={event.image} alt={event.title} sx={{ height: 200, objectFit: 'cover' }} />
                            <CardContent>
                                <Typography variant="body2">{event.summary}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Stack>
    );
};

export default Events; 